<template>
  <div class="document-upload">
    <div v-if="value" class="file-row">
      <i class="el-icon-document" />
      <span class="file-name" :title="value">{{ fileName }}</span>
      <el-button size="mini" type="text" class="danger" @click="clear">移除</el-button>
    </div>
    <el-upload
      class="upload-drop"
      drag
      action="#"
      :auto-upload="false"
      :show-file-list="false"
      :accept="accept"
      :disabled="uploading"
      :on-change="handleChange"
    >
      <i class="el-icon-upload" />
      <div class="el-upload__text">{{ hint }}</div>
    </el-upload>
  </div>
</template>

<script>
import { uploadFile } from '@/api/upload'
import { normalizeFileUrl } from '@/utils/fileUrl'

const MAX_FILE_SIZE = 100 * 1024 * 1024
const ALLOWED_DOC_EXT = ['pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'zip', 'rar', '7z', 'txt']

export default {
  name: 'DocumentUpload',
  props: {
    value: { type: String, default: '' },
    bizType: { type: String, default: 'cms_material' },
    accept: {
      type: String,
      default: '.pdf,.doc,.docx,.ppt,.pptx,.zip,.rar,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/zip'
    },
    hint: {
      type: String,
      default: '点击上传材料文件（PDF、Word、PPT、ZIP 等）'
    },
    maxSize: { type: Number, default: MAX_FILE_SIZE }
  },
  data() {
    return { uploading: false }
  },
  computed: {
    fileName() {
      if (!this.value) return ''
      const parts = this.value.split('/')
      return parts[parts.length - 1] || this.value
    }
  },
  methods: {
    clear() {
      this.$emit('input', '')
    },
    async handleChange(fileObj) {
      const file = fileObj && fileObj.raw
      if (!file) return
      const ext = (file.name.split('.').pop() || '').toLowerCase()
      if (!ALLOWED_DOC_EXT.includes(ext)) {
        this.$message.warning('不支持的文件格式')
        return
      }
      if (file.size > this.maxSize) {
        this.$message.warning('文件大小超出限制')
        return
      }
      this.uploading = true
      try {
        const result = await uploadFile(file, this.bizType, { useAdmin: true })
        this.$emit('input', normalizeFileUrl(result.url))
        this.$emit('uploaded', file)
        this.$message.success('上传成功')
      } catch (e) {
      } finally {
        this.uploading = false
      }
    }
  }
}
</script>

<style scoped>
.document-upload {
  width: 100%;
}
.file-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 4px;
  color: #606266;
}
.file-name {
  flex: 1;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-drop >>> .el-upload {
  width: 100%;
}
.upload-drop >>> .el-upload-dragger {
  width: 100%;
  height: 120px;
}
.danger {
  color: #f56c6c;
}
</style>
